import { FC } from 'react';
import PageTitle from 'components/PageTitle';
import UnsavedChangeModal from '../Roles/Form/UnsavedChangeModal';
import { PageTitleProps } from 'components/PageTitle/PageTitle';
import {
  GraniteButton,
  GraniteButtonProps,
} from 'components/V2/Button/GraniteButton';
import { useNavigate } from 'react-router-dom';

interface CustomRoleHeaderProps
  extends Pick<PageTitleProps, 'title' | 'breadcrumbs'> {
  isDirty?: boolean;
  buttonAction?: Omit<GraniteButtonProps, 'ref'>;
  withUnsavedChangeModal?: boolean;
}

const CustomRoleHeader: FC<CustomRoleHeaderProps> = ({
  title,
  breadcrumbs,
  isDirty = false,
  buttonAction,
  withUnsavedChangeModal = false,
}) => {
  const navigate = useNavigate();
  const _breadcrumbs = [
    {
      icon: 'home',
      label: 'User management',
      onClick: () => navigate('/users'),
    },
    {
      label: 'Role management',
      onClick: () => navigate('/users/custom-roles'),
    },
    ...(breadcrumbs || []),
  ];

  return (
    <div className="mb-2 flex flex-col justify-between gap-2 md:flex-row md:items-center">
      <PageTitle title={title} breadcrumbs={_breadcrumbs} />
      <div className="flex gap-4">
        {withUnsavedChangeModal && <UnsavedChangeModal isDirty={isDirty} />}
        {buttonAction && (
          <GraniteButton {...buttonAction}>
            {buttonAction.children}
          </GraniteButton>
        )}
      </div>
    </div>
  );
};

export default CustomRoleHeader;
